module.exports = __webpack_public_path__ + "img/source_sw-item5.3b201281.png";